import './vendor/ajax.min.js';
import { LoadOMatic } from './vendor/load-o-matic.js';

// import { breakpoints } from '../variables.yml';

import 'focus-visible';
import { FormDataObject, formDataToObject } from './types';
// import './vendor/lib.js';
// import { whatever } from './vendor/lib.js';
// import { getWindowWidth } from './helpers.js';

export * from './CookieConsentManager.js';
// export * from './vue/app.js';

declare global {
	interface Window {
		GoodCausesSummaries: ( buildLoadOMatic ) => void; // eslint-disable-line snakecasejs/snakecasejs
		runPageScript: () => void; // eslint-disable-line snakecasejs/snakecasejs
	}
}

function doToggle( toggler ) {
	const togglees = document.querySelectorAll( toggler.getAttribute( 'data-togglees' ) );
	let revert_values = false;

	if ( toggler.getAttribute( 'data-revert-values' ) && toggler.getAttribute( 'data-revert-values' ) === 'true' ) {
		revert_values = true;
	}

	for ( let i = 0; i < togglees.length; i += 1 ) {
		togglees[i].classList.toggle( 'toggled' );

		if ( revert_values ) {
			const inputs_to_revert = togglees[i].querySelectorAll( '[data-original-value]' );

			for ( let x = 0; x < inputs_to_revert.length; x += 1 ) {
				inputs_to_revert[x].value = inputs_to_revert[x].getAttribute( 'data-original-value' );
			}

			const checkables_to_revert = togglees[i].querySelectorAll( '[data-originally-checked]' );

			for ( let y = 0; y < checkables_to_revert.length; y += 1 ) {
				checkables_to_revert[y].checked = checkables_to_revert[y].getAttribute( 'data-originally-checked' );
			}
		}
	}
	toggler.classList.toggle( 'toggler--toggled' );
}

function doPopulatedToggle( toggler ) {
	const togglees = document.querySelectorAll( toggler.getAttribute( 'data-togglees' ) );

	for ( let i = 0; i < togglees.length; i += 1 ) {
		if ( toggler.value.length > 0 ) {
			togglees[i].classList.remove( 'toggled' );
		} else {
			togglees[i].classList.add( 'toggled' );
		}
	}
	toggler.classList.toggle( 'toggler--toggled' );
}

( () => {
	window.addEventListener( 'click', ( event ) => {
		const { target } = event;
		if ( target instanceof HTMLElement ) { // eslint-disable-line snakecasejs/snakecasejs
			const class_list = target.classList; // DOMTokenList
			if ( !class_list.contains( 'toggler' ) ) {
				return;
			}
		}
		event.preventDefault();
		doToggle( target );
	} );

	window.addEventListener( 'change', ( event ) => {
		const { target } = event;
		if ( target instanceof HTMLElement ) { // eslint-disable-line snakecasejs/snakecasejs
			const class_list = target.classList; // DOMT
			if ( !class_list.contains( 'change-toggler' ) ) {
				return;
			}
		}
		doToggle( target );
	} );

	window.addEventListener( 'change', ( event ) => {
		const { target } = event;
		if ( target instanceof HTMLElement ) { // eslint-disable-line snakecasejs/snakecasejs
			const class_list = target.classList; // DOMT
			if ( !class_list.contains( 'populated-toggler' ) ) {
				return;
			}
		}
		doPopulatedToggle( target );
	} );
} )();


let request_pending = false;
( () => {
	let current_focus;

	function autocomplete( autocomplete_button ) {
		/* the autocomplete function takes one argument; the text field element: */
		if ( !autocomplete_button.getAttribute( 'data-input' ) ) {
			return;
		}
		const inp = document.querySelector( autocomplete_button.getAttribute( 'data-input' ) );

		if ( !inp ) {
			return;
		}
		/* execute a function when someone writes in the text field: */
		autocomplete_button.addEventListener( 'click', ( e ) => {
			test_request_pending( e.target, inp );
		} );
		/* execute a function presses a key on the keyboard: */
		inp.addEventListener( 'keydown' , function( e ) {
			const x = document.querySelector( '#' + inp.id + 'autocomplete-list' );
			let y;
			if ( x ) {
				y = x.querySelectorAll( ':scope > div' );
			}
			if ( e.code === 'ArrowDown' ) {
				/* If the arrow DOWN key is pressed, increase the current_focus variable: */
				current_focus++;
				/* and and make the current item more visible: */
				addActive( y );
			} else if ( e.code === 'ArrowUp' ) { //up
				/* If the arrow UP key is pressed, decrease the current_focus variable: */
				current_focus--;
				/* and and make the current item more visible: */
				addActive( y );
			} else if ( e.code === 'Enter' ) {
				/* If the ENTER key is pressed, prevent the form from being submitted, */
				e.preventDefault();
				if ( current_focus > -1 ) {
					/* and simulate a click on the "active" item: */
					if ( y ) {
						y[ current_focus ].click();
					}
				}
			}
		} );


		/* execute a function when someone clicks in the document: */
		document.addEventListener( 'click', ( e ) => {
			closeAllLists( inp, e.target );
		} );
	}

	function test_request_pending( button, inp ) {
		button.disabled = true;
		button.classList.remove( 'form__submit--search-icon' );
		button.classList.add( 'form__submit--loader-icon' );

		if ( !request_pending ) {
			query_results( button, inp );
		} else {
			setTimeout( () => {
				test_request_pending( button, inp );
			}, 200 );
		}
	}

	function query_results( button, inp ) {
		let b;
		let i;
		const val = inp.value;
		/* close any already open lists of autocompleted values */
		closeAllLists( inp );
		if ( !val || val === '' ) {
			return false;
		}
		request_pending = true;
		current_focus = -1;
		inp.focus();

		fetch( '/search/recipients?q=' + val, {
			method: 'get',
			headers: {
				'Accept': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			}
		} )
			.then( response => response.json() )
			.then( parsed_response => {
				button.disabled = false;
				button.classList.add( 'form__submit--search-icon' );
				button.classList.remove( 'form__submit--loader-icon' );
				const results = parsed_response;
				const int_results = results.length;
				/* create a DIV element that will contain the items (values): */
				const a = document.createElement( 'div' );
				a.setAttribute( 'id', inp.id + 'autocomplete-list' );
				a.setAttribute( 'class', 'form__autocomplete-items' );
				/* for each item in the array... */
				for ( i = 0; i < int_results; i++ ) {
					/* create a DIV element for each matching element: */
					b = document.createElement( 'div' );
					b.classList.add( 'form__autocomplete-items__item' );
					let inner_html = '';
					let str_pos;
					/* check if the item starts with the same letters as the text field value: */
					if ( results[ i ].title !== null ) {
						str_pos = results[ i ].title.toUpperCase().indexOf( val.toUpperCase() );

						/* make the matching letters bold: */
						inner_html += '<div class="form__autocomplete-items__item__title">';
						if ( str_pos > -1 ) {
							inner_html += results[ i ].title.substr( 0, str_pos );
							inner_html += '<strong>' + results[ i ].title.substr( str_pos, val.length ) + '</strong>';
							inner_html += results[ i ].title.substr( str_pos + val.length ) + '</div>';
						} else {
							inner_html += results[ i ].title;
						}
					}

					str_pos = results[ i ].unique_id.toUpperCase().indexOf( val.toUpperCase() );

					if ( str_pos > -1 ) {
						inner_html += '<div>' + results[ i ].unique_id.substr( 0, str_pos );
						inner_html += '<strong>' + results[ i ].unique_id.substr( str_pos, val.length ) + '</strong>';
						inner_html += results[ i ].unique_id.substr( str_pos + val.length ) + '</div>';
					} else {
						inner_html += '<div>' + results[ i ].unique_id + '</div>';
					}
					inner_html += '<div>' + results[ i ].uk_constituency + ', ' + results[ i ].region + '</div>';
					/* insert a input field that will hold the current array item's value: */
					inner_html += '<input type="hidden" value="' + results[ i ].unique_id + '" data-title="' + results[ i ].title + '" data-unique-id="' + results[ i ].unique_id + '">';

					b.innerHTML = inner_html;
					/* execute a function when someone clicks on the item value (DIV element): */
					b.addEventListener( 'click', function() {
						/* insert the value for the autocomplete text field: */
						const hidden_input = this.getElementsByTagName( 'input' )[ 0 ];
						inp.value = hidden_input.value;
						doToggle( inp );

						if ( inp.getAttribute( 'data-grant-recipient-name' ) && hidden_input.getAttribute( 'data-title' ) ) {
							const grant_recipient_name = document.querySelector( inp.getAttribute( 'data-grant-recipient-name' ) );

							if ( grant_recipient_name && hidden_input.getAttribute( 'data-title' ) !== 'null' ) {
								grant_recipient_name.innerText = hidden_input.getAttribute( 'data-title' );
							}
						}

						if ( inp.getAttribute( 'data-grant-recipient-id' ) && hidden_input.getAttribute( 'data-unique-id' ) ) {
							const grant_recipient_id = document.querySelector( inp.getAttribute( 'data-grant-recipient-id' ) );

							if ( grant_recipient_id ) {
								grant_recipient_id.innerText = hidden_input.getAttribute( 'data-unique-id' );
							}
						}

						/* close the list of autocompleted values (or any other open lists of autocompleted values:) */
						closeAllLists( inp );
					} );
					a.appendChild( b );
				}
				closeAllLists( inp );
				if ( int_results > 0 ) {
					/* append the DIV element as a child of the autocomplete container: */
					inp.parentNode.appendChild( a );
				} else {
					b = document.createElement( 'div' );
					b.classList.add( 'form__autocomplete-items__no-results' );
					const inner_html = '<div>No results found</div>';
					a.appendChild( b );
					b.innerHTML = inner_html;
					inp.parentNode.appendChild( a );
				}
				request_pending = false;
			} )
			.catch( console.error ); // eslint-disable-line no-console
	}

	function addActive( x ) {
		/* a function to classify an item as "active": */
		if ( !x ) {
			return false;
		}
		/* start by removing the "active" class on all items: */
		removeActive( x );
		if ( current_focus >= x.length ) {
			current_focus = 0;
		}
		if ( current_focus < 0 ) {
			current_focus = ( x.length - 1 );
		}
		/* add class "autocomplete-active": */
		x[ current_focus ].classList.add( 'autocomplete-active' );
	}

	function removeActive( x ) {
		/*a function to remove the "active" class from all autocomplete items: */
		for ( let i = 0; i < x.length; i++ ) {
			x[ i ].classList.remove( 'autocomplete-active' );
		}
	}

	const autocomplete_buttons = document.querySelectorAll( '.js__autocomplete-search' );

	if ( !autocomplete_buttons ) {
		return;
	}

	for ( let i = 0; i < autocomplete_buttons.length; i++ ) {
		const autocomplete_button = autocomplete_buttons[ i ];

		autocomplete( autocomplete_button );
	}

	const autocomplete_inputs = document.querySelectorAll( '.js__autocomplete-search-enter' );

	autocomplete_inputs.forEach( ( autocomplete_input ) => {
		autocomplete_input.addEventListener( 'keydown', ( event ) => {
			if ( ( event as KeyboardEvent ).code === 'Enter' ) {
				event.preventDefault();
				event.stopImmediatePropagation();

				if ( autocomplete_input.getAttribute( 'data-search-button' ) ) {
					const search_button = document.querySelector( autocomplete_input.getAttribute( 'data-search-button' ) );

					if ( search_button ) {
						query_results( search_button, autocomplete_input );
					}
				}
			}
		} );
	} );
} )();

function closeAllLists( inp, elmnt = null ) {
	/* close all autocomplete lists in the document, except the one passed as an argument: */
	const x = document.getElementsByClassName( 'form__autocomplete-items' );
	for ( let i = 0; i < x.length; i++ ) {
		if ( elmnt === null || ( elmnt !== x[ i ] && elmnt !== inp ) ) {
			x[ i ].parentNode.removeChild( x[ i ] );
		}
	}
}

( () => {
	const address_lookup_inputs = document.querySelectorAll( '.js__address-lookup' );

	if ( !address_lookup_inputs ) {
		return;
	}

	for ( let i = 0; i < address_lookup_inputs.length; i++ ) {
		const address_lookup_input = address_lookup_inputs[ i ];
		test_request_pending( address_lookup_input );
	}

	function query_addresses( address_lookup_input ) {

		address_lookup_input.addEventListener( 'input', ( e ) => {
			const input = e.target as HTMLTextAreaElement;
			const val = input.value;
			const api_key = 'uPw191rakG0WJ338AEMroAJ8MkTCBp6G';
			let b;
			/* close any already open lists of autocompleted values */
			closeAllLists( input );
			request_pending = true;

			fetch( 'https://api.os.uk/search/places/v1/find?query=' + val + '&key=' + api_key, {
				method: 'GET',
			} )
				.then( response => response.json() )
				.then( parsed_response => {
					const results = parsed_response.results;
					const int_results = results === undefined ? 0 : results.length;
					/* create a DIV element that will contain the items (values): */
					const a = document.createElement( 'div' );
					a.setAttribute( 'id', input.id + 'autocomplete-list' );
					a.setAttribute( 'class', 'form__autocomplete-items' );
					/* for each item in the array... */
					for ( let i = 0; i < int_results; i++ ) {
						/* create a DIV element for each matching element: */
						b = document.createElement( 'div' );
						b.classList.add( 'form__autocomplete-items__item' );
						let inner_html = '';
						/* check if the address starts with the same letters as the text field value: */
						const str_pos = results[ i ].DPA.ADDRESS.toUpperCase().indexOf( val.toUpperCase() );

						/* make the matching letters bold: */
						inner_html += '<div class="form__autocomplete-items__item__title">';
						if ( str_pos > -1 ) {
							inner_html += results[ i ].DPA.ADDRESS.substr( 0, str_pos );
							inner_html += '<strong>' + results[ i ].DPA.ADDRESS.substr( str_pos, val.length ) + '</strong>';
							inner_html += results[ i ].DPA.ADDRESS.substr( str_pos + val.length );
						} else {
							inner_html += results[ i ].DPA.ADDRESS;
						}
						inner_html += '</div>';

						/* insert a input field that will hold the current array item's value: */
						inner_html += '<input type="hidden" data-address-1="';
						if ( results[ i ].DPA.BUILDING_NUMBER ) {
							inner_html += results[ i ].DPA.BUILDING_NUMBER + ' ';
						}
						if ( results[ i ].DPA.BUILDING_NAME ) {
							inner_html += results[ i ].DPA.BUILDING_NAME + ' ';
						}
						if ( results[ i ].DPA.THOROUGHFARE_NAME ) {
							inner_html += results[ i ].DPA.THOROUGHFARE_NAME + ' ';
						}

						inner_html += '" data-town="' + results[ i ].DPA.POST_TOWN + '" data-postcode="' + results[ i ].DPA.POSTCODE + '">';

						b.innerHTML = inner_html;
						/* execute a function when someone clicks on the item value (DIV element): */
						b.addEventListener( 'click', ( e ) => {
							const clicked_input = e.target as HTMLTextAreaElement;
							/* insert the value for the autocomplete text field: */
							const hidden_input = clicked_input.parentNode.querySelector( 'input' );

							if ( input.getAttribute( 'data-address-manual' ) ) {
								const address_manual = document.querySelectorAll( input.getAttribute( 'data-address-manual' ) );

								for ( let y = 0; y < address_manual.length; y++ ) {
									address_manual[ y ].classList.add( 'toggled' );
								}
							}

							if ( input.getAttribute( 'data-address-inputs' ) ) {
								const address_inputs = document.querySelectorAll( input.getAttribute( 'data-address-inputs' ) );

								for ( let v = 0; v < address_inputs.length; v++ ) {
									address_inputs[ v ].classList.remove( 'toggled' );
								}
							}

							if ( input.getAttribute( 'data-address-1' ) && hidden_input.getAttribute( 'data-address-1' ) ) {
								const address_1 = document.querySelector( input.getAttribute( 'data-address-1' ) ) as HTMLTextAreaElement;

								if ( address_1 ) {
									address_1.value = hidden_input.getAttribute( 'data-address-1' );
								}
							}

							if ( input.getAttribute( 'data-town' ) && hidden_input.getAttribute( 'data-town' ) ) {
								const town = document.querySelector( input.getAttribute( 'data-town' ) ) as HTMLTextAreaElement;

								if ( town ) {
									town.value = hidden_input.getAttribute( 'data-town' );
								}
							}

							if ( input.getAttribute( 'data-postcode' ) && hidden_input.getAttribute( 'data-postcode' ) ) {
								const postcode = document.querySelector( input.getAttribute( 'data-postcode' ) ) as HTMLTextAreaElement;

								if ( postcode ) {
									postcode.value = hidden_input.getAttribute( 'data-postcode' );
								}
							}

							/* close the list of autocompleted values (or any other open lists of autocompleted values:) */
							closeAllLists( input );
						} );
						a.appendChild( b );
					}
					closeAllLists( input );
					if ( int_results > 0 ) {
						/* append the DIV element as a child of the autocomplete container: */
						input.parentNode.appendChild( a );
					} else {
						b = document.createElement( 'div' );
						b.classList.add( 'form__autocomplete-items__no-results' );
						const inner_html = '<div>No address found</div>';
						a.appendChild( b );
						b.innerHTML = inner_html;
						input.parentNode.appendChild( a );
					}
					request_pending = false;
				} )
				.catch( console.error ); // eslint-disable-line no-console
		} );
	}

	function test_request_pending( inp ) {
		if ( !request_pending ) {
			query_addresses( inp );
		} else {
			setTimeout( () => {
				test_request_pending( inp );
			}, 200 );
		}
	}
} )();

( () => {
	// Dynamic word count fields.
	const word_count_fields = document.querySelectorAll( '[data-word-count]' );
	for ( let i = 0; i < word_count_fields.length; i++ ) {
		word_count_fields[i].addEventListener( 'keyup', () => {
			check( word_count_fields[i] );
		} );
		check( word_count_fields[i] );
	}

	function	check( word_count_field ) {
		if ( word_count_field.getAttribute( 'data-word-count' ) && word_count_field.getAttribute( 'data-words-allowed' ) ) {
			const target = document.getElementById( word_count_field.getAttribute( 'data-word-count' ) );
			const words_allowed = parseInt( word_count_field.getAttribute( 'data-words-allowed' ) );

			if ( target ) {
				const regex = /[^\s]?(\s+)[^\s]/g;

				let word_count = 0;
				if ( word_count_field.value.length > 0 ) {
					const matches = word_count_field.value.match( regex );
					if ( matches === null ) {
						word_count = 1;
					} else {
						// There's always one more word than spaces between words, so we add 1.
						word_count = matches.length + 1;
					}
				}

				let words_text = '';
				const words_remaining_message = target.parentElement.querySelector( '.words-remaining-message' );
				const words_over_message = target.parentElement.querySelector( '.words-over-message' );
				if ( words_allowed >= word_count ) {
					words_text = String( words_allowed - word_count );
					word_count_field.classList.remove( 'form__input--error' );
					if ( words_remaining_message ) {
						words_remaining_message.classList.remove( 'toggled' );
					}
					if ( words_over_message ) {
						words_over_message.classList.add( 'toggled' );
					}
				} else {
					words_text = String( word_count - words_allowed );
					word_count_field.classList.add( 'form__input--error' );
					if ( words_remaining_message ) {
						words_remaining_message.classList.add( 'toggled' );
					}
					if ( words_over_message ) {
						words_over_message.classList.remove( 'toggled' );
					}
				}

				target.innerHTML = String( words_text );
			}
		}
	}
} )();

function removeAsset( remove_button ) {
	const asset_inputs = document.querySelectorAll( remove_button.getAttribute( 'data-asset' ) );

	if ( asset_inputs ) {
		for ( let i = 0; i < asset_inputs.length; i += 1 ) {
			asset_inputs[i].value = '';
		}
	}
}

( () => {
	window.addEventListener( 'click', ( event ) => {
		const { target } = event;
		if ( target instanceof HTMLElement ) { // eslint-disable-line snakecasejs/snakecasejs
			const class_list = target.classList; // DOMTokenList
			if ( !class_list.contains( 'remove-asset' ) ) {
				return;
			}
		}
		event.preventDefault();
		removeAsset( target );
	} );
} )();

( () => {
	// Dropdowns
	const dropdown_elements = document.querySelectorAll( '.dropdown-set' );

	function openDropdown( dropdown_element ) {
		dropdown_element.classList.add( 'dropdown-set--open' );

		const button = dropdown_element.querySelector( '.dropdown-set__toggle-button' );
		button.setAttribute( 'aria-expanded', 'true' );
	}

	function closeDropdown( dropdown_element ) {
		dropdown_element.classList.remove( 'dropdown-set--open' );

		const button = dropdown_element.querySelector( '.dropdown-set__toggle-button' );
		button.setAttribute( 'aria-expanded', 'false' );
	}


	function toggleDropdown( dropdown_element ) {
		if ( dropdown_element.classList.contains( 'dropdown-set--open' ) ) {
			closeDropdown( dropdown_element );
		} else {
			openDropdown( dropdown_element );
		}
	}

	document.body.addEventListener( 'click', ( event ) => {
		const target = event.target  as HTMLElement;
		const class_list = target.classList; // DOMTokenList
		if ( !class_list.contains( 'dropdown-set__toggle-button' ) ) {
			for ( let i = 0; i < dropdown_elements.length; i += 1 ) {
				closeDropdown( dropdown_elements[ i ] );
			}
			return;
		}

		for ( let i = 0; i < dropdown_elements.length; i += 1 ) {
			if ( dropdown_elements[ i ] === target.parentNode ) {
				toggleDropdown( dropdown_elements[ i ] );
				continue;
			}
			closeDropdown( dropdown_elements[ i ] );
		}
	} );
} )();

let loadomatic;
// eslint-disable-next-line snakecasejs/snakecasejs
const buildLoadOMatic = ( options ) => {
	const container = document.querySelector( '.loadomatic' );
	if ( !container ) {
		return;
	}

	loadomatic = new LoadOMatic( options ); // eslint-disable-line @typescript-eslint/no-unused-vars
};

( () => { // Loadomaitc Search and Filters
	const search_form = document.querySelector<HTMLFormElement>( '#js-search-form' );
	const results_container = document.querySelector( '.loadomatic' );

	if ( !search_form || !results_container ) {
		return;
	}

	const segments = window.location.pathname.split( '/' );

	search_form.addEventListener( 'submit', ( e ) => {
		e.preventDefault();
		handleFormChange();
	} );

	search_form.addEventListener( 'change', () => {
		handleFormChange();
	} );

	function getUrlFromForm( form, clear ) {
		let first_segment = segments[1];
		const second_segment = segments[2];
		if ( second_segment === 'team' || second_segment === 'portfolio' ) {
			first_segment = second_segment;
		}
		const form_data = new FormData( form );
		const params: FormDataObject = formDataToObject( form_data );
		const search_url = `${first_segment}${ clear ? '' : '?' + new URLSearchParams( params ).toString() }`;
		return search_url;
	}

	function handleFormChange( clear = false ) {
		const search_url = getUrlFromForm( search_form, clear );
		window.history.pushState( null, null, search_url );
		loadomatic.loadMore( true, false );
		loadomatic.handleTrigger();
	}
} )();

window.runPageScript = function() {
	if ( typeof window.GoodCausesSummaries === 'function' ) {
		window.GoodCausesSummaries( {
			buildLoadOMatic: buildLoadOMatic,
		} );
	}
};

window.runPageScript();
